import { api as deliveryApi, configs as deliveryConfigs } from './delivery'
import useMadeFromScratchSummary, {
  madeFromScratchSummaryConfigs,
} from './useMadeFromScratchSummary'
import useSystemwideOverviewKpis, {
  systemwideOverviewKpisConfigs,
} from './useSystemwideOverviewKpis'

export const configs = {
  ...deliveryConfigs,
  systemwideOverviewKpis: systemwideOverviewKpisConfigs,
  madeFromScratchSummary: madeFromScratchSummaryConfigs,
}

export const api = {
  ...deliveryApi,
  systemwideOverviewKpis: useSystemwideOverviewKpis,
  madeFromScratchSummary: useMadeFromScratchSummary,
}
